import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2511">
      <Navbar data-id="element-2512" />
      <main data-id="element-2513">
        <ConsularAffairs data-id="element-2514" />
      </main>
      <Footer data-id="element-2515" />
      <FeedbackPopup data-id="element-2516" />
    </div>;
}